<alg-notification-modal
  [modalTitle]="title()"
  [icon]="error().isForbidden ? 'ph ph-prohibit' : 'ph ph-warning'"
  (closeEvent)="dialogRef.close()"
>
  <p class="message text-center">
    @if (error().isForbidden) {
      <ng-container i18n>You are not allowed to watch the group for which you have requested observation.</ng-container>
    } @else {
      <ng-container i18n>Something went wrong while enabling group observation. If the problem persists, please contact us.</ng-container>
    }
  </p>
</alg-notification-modal>
